/**
 * Fetch with auth headers if available
 */
import _fetch from 'cross-fetch';

import { setAuthHeaders, storeAuthHeaders } from '~/modules/auth';

export type fetch = typeof _fetch;

export type PiczelThunk = (
  dispatch: (action: any) => void,
  getState: () => RootState,
  fetch: fetch
) => Promise<any>;
export type PiczelAsyncAction = (
  dispatch: (action: any) => void,
  getState: () => RootState,
  fetch: fetch
) => Promise<any>;

/**
 * Makes the fetch function (with auth headers) available inside action creators
 * @param {Function} getState
 */
export function configureFetch(getState, dispatch) {
  return function newFetch(url: string | URL, options: RequestInit = {}) {
    const state = getState();

    const { isSignedIn } = state.currentUser;
    const currentAuthToken = state.auth;

    if (isSignedIn) {
      if (options.headers) {
        options.headers = {
          ...currentAuthToken,
          ...options.headers,
        };
      } else {
        options.headers = currentAuthToken;
      }
    }

    const baseFetch =
      process.env.NODE_ENV === 'test' ? _fetch : global.fetch || _fetch;

    if (typeof _fetch !== 'function') {
      throw new Error(
        'Fetch is not available in this environment. Please ensure you are using a compatible version of Node.js or a polyfill.'
      );
    }

    return baseFetch(url, options).then((response) => {
      const responseHeaders = response.headers;

      if (
        currentAuthToken['access-token'] &&
        responseHeaders.get('access-token') &&
        responseHeaders.get('access-token') !== currentAuthToken['access-token']
      ) {
        const newAuthHeaders = {
          'access-token': responseHeaders.get('access-token'),
          client: responseHeaders.get('client'),
          uid: responseHeaders.get('uid'),
        };

        dispatch(setAuthHeaders(newAuthHeaders));
        storeAuthHeaders(responseHeaders, {});
      }

      return response;
    });
  };
}
